<template>
  <div class="live">
<!--    <div class="banner"></div>-->
    <div class="indexCourse">
      <ul class="publick">
        <li v-for="(item, index) in info" :key="index">
          <router-link :to="{ path: '/CourseDetails', query: { id: item.id }  }">
            <div class="img">
              <img :src="item.cover" width="287" height="175" alt="">
              <div v-if="item.tag" class="hot">{{item.tag}}</div>
              <div class="label">
                <span v-for="(items, indexs) in item.level" :key="indexs">{{items.name}}</span>
              </div>
            </div>
            <div class="describe line-clamp-2">{{item.title}}</div>
            <div class="num">
              <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
              <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <layerRight></layerRight>
  </div>
</template>

<script>
  import layerRight from '@/components/layerRight/layerRight'

  export default {
    components: {
      layerRight
    },
    data () {
      return {
        info: {}
      }
    },
    created () {
      this.getData()
    },
    methods: {
      getData () {
        this.$http.post('/apipx/Live/lists', {
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .live {
    .banner {
      width: 100%;
      height: 350px;
      background: url("banner.png") no-repeat center center;
    }

    .indexCourse {
      width: 100%;
      overflow: hidden;
      box-shadow: 0px 20px 20px -20px #f5f5f5;
      margin: 30px auto;
      min-height: 70vh;

      li {
        width: 287px;
        overflow: hidden;
        float: left;
        margin: 50px 17.3px 0 0;
        cursor: pointer;

        &:nth-child(4n) {
          margin-right: 0;
        }

        .img {
          width: 287px;
          height: 175px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          .hot {
            position: absolute;
            width: 50px;
            height: 35px;
            border-radius: 0 17.5px 17.5px 0;
            background-color: #fff;
            text-align: center;
            line-height: 35px;
            color: #fc8375;
            font-size: 14px;
            font-weight: bold;
            left: 0;
            top: 20px;
          }

          .label {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 20px;

            span {
              background-color: rgba(0, 0, 0, 0.5);
              color: #fff;
              padding: 5px 8px;
              border-radius: 10px;
              margin: 0 0 0 10px;
            }
          }
        }

        .describe {
          width: 287px;
          height: 50px;
          line-height: 25px;
          margin-top: 25px;
        }

        .num {
          height: 20px;
          width: 100%;
          font-size: 12px;
          color: #8f8f8f;
          margin-top: 10px;

          img {
            display: block;
            float: left;
          }

          .people {
            line-height: 20px;
            margin-right: 20px;

            img {
              margin: 3px 5px 0 0;
            }
          }

          .comment {
            line-height: 20px;

            img {
              margin: 5px 5px 0 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/live/live.vue